module YesNoButton {
  const parentElementClass = "yes-no-button";

  export function construct() {
    $(`.${parentElementClass} button`).click(buttonClicked);
  }

  function buttonClicked() {
    const element = $(this);
    const value = getValue(element);
    const newValue = !value;
    setValue(element, newValue);
  }

  function getYesButton(thisElement: JQuery<HTMLElement>) {
    const parent = getParentElement(thisElement);
    return parent.find("button").eq(0);
  }

  function getNoButton(thisElement: JQuery<HTMLElement>) {
    const parent = getParentElement(thisElement);
    return parent.find("button").eq(1);
  }

  function getParentElement(thisElement: JQuery<HTMLElement>) {
    return thisElement.parents(`.${parentElementClass}`);
  }

  function getInput(thisElement: JQuery<HTMLElement>) {
    const parent = getParentElement(thisElement);
    return parent.find("input");
  }

  function getValue(thisElement: JQuery<HTMLElement>) {
    const input = getInput(thisElement);
    return input.val() == "True";
  }

  function setValue(thisElement: JQuery<HTMLElement>, newValue: boolean) {
    const input = getInput(thisElement);
    input.val(newValue ? "True" : "False");

    const yesButton = getYesButton(thisElement);
    const noButton = getNoButton(thisElement);
    if (newValue) {
      yesButton.show();
      noButton.hide();
    }
    else {
      yesButton.hide();
      noButton.show();
    }
    input.change();
  }
}